// Axios
import axios from "src/lib/axios"

// --------------------------------------------|| TICKETS - SERVICES || -------------------------------------------

const getTransactionList = filter => {
  return axios.get("/api/v1/payment/getTransactionList", {
    params: filter
  })
}

const getTransactionTypeFilter = () => {
  return axios.get("/api/v1/common/getAllTypeByGroupId", {
    params: {
      id: 7
    }
  })
}

const TransactionServices = { getTransactionList, getTransactionTypeFilter }

export default TransactionServices
